import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Send } from "lucide-react";

export default function AdminNotifications() {
  const [form, setForm] = useState({ channel: "whatsapp", audience: "all", subject: "", message: "" });
  const [history, setHistory] = useState([]);
  const load = async () => setHistory((await api.get("/admin/notifications")).data);
  useEffect(() => { load(); }, []);
  const send = async () => {
    if (!form.message) return toast.error("Message required");
    try { await api.post("/admin/notifications", form); toast.success("Sent (mocked)"); setForm({...form, subject: "", message: ""}); load(); }
    catch { toast.error("Failed"); }
  };
  return (
    <div>
      <div className="text-xs uppercase tracking-[0.4em] text-[#39FF14]">Broadcast</div>
      <h1 className="font-display text-4xl mt-2">Notifications</h1>
      <div className="mt-4 p-3 bg-[#FFD700]/10 border border-[#FFD700]/30 text-[#FFD700] text-xs uppercase tracking-widest">Notifications are MOCKED — integrate SMS/WhatsApp/Email providers later.</div>

      <div className="mt-6 grid md:grid-cols-2 gap-6">
        <div className="p-6 bg-[#0B132B] border border-white/10 rounded space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <select value={form.channel} onChange={(e)=>setForm({...form, channel: e.target.value})} className="bg-black/50 border border-white/15 px-3 py-2 text-sm" data-testid="notif-channel">
              {["whatsapp","sms","email"].map(c=><option key={c} value={c} className="bg-[#0B132B]">{c.toUpperCase()}</option>)}
            </select>
            <select value={form.audience} onChange={(e)=>setForm({...form, audience: e.target.value})} className="bg-black/50 border border-white/15 px-3 py-2 text-sm" data-testid="notif-audience">
              {["all","approved","pending"].map(c=><option key={c} value={c} className="bg-[#0B132B]">{c.toUpperCase()} PLAYERS</option>)}
            </select>
          </div>
          {form.channel === "email" && <input placeholder="Subject" value={form.subject} onChange={(e)=>setForm({...form, subject: e.target.value})} className="w-full bg-black/50 border border-white/15 px-3 py-2 text-sm"/>}
          <textarea rows="6" placeholder="Your message…" value={form.message} onChange={(e)=>setForm({...form, message: e.target.value})} className="w-full bg-black/50 border border-white/15 px-3 py-2 text-sm" data-testid="notif-message"/>
          <button onClick={send} data-testid="notif-send" className="w-full py-3 bg-[#39FF14] text-black font-bold uppercase tracking-widest flex items-center gap-2 justify-center"><Send size={14}/>Send</button>
        </div>
        <div className="p-6 bg-[#0B132B] border border-white/10 rounded">
          <div className="text-xs uppercase tracking-widest text-white/60 mb-3">History</div>
          <div className="space-y-2 max-h-[500px] overflow-y-auto">
            {history.length === 0 && <div className="text-white/40 text-sm">No notifications yet.</div>}
            {history.map((h) => (
              <div key={h.id} className="p-3 bg-black/30 border border-white/10">
                <div className="flex justify-between text-xs">
                  <span className="text-[#39FF14] uppercase">{h.channel} • {h.audience} ({h.recipients})</span>
                  <span className="text-white/40">{new Date(h.created_at).toLocaleString()}</span>
                </div>
                {h.subject && <div className="mt-1 font-medium text-sm">{h.subject}</div>}
                <div className="mt-1 text-white/70 text-sm">{h.message}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
